import { Icon, Tooltip } from '@dixa/lib-shared-habla';
import { typography } from '@dixa/lib-shared-tokens';
import type { ConversationAgentPreference } from 'lib-shared-types-api';

import { ConversationTimestamp } from 'components/conversation/components/conversationTimestamp/conversationTimestamp';
import { getUserDisplayName } from 'utils/user';

import styles from './conversationsTableAgentPreferenceTooltip.module.scss';

type ConversationsTableAgentPreferenceTooltipProps = {
  /** An agent preference that still applies. */
  agentPreference: ConversationAgentPreference;
};

const prettyAgentPreferenceType: Record<
  ConversationAgentPreference['agent_preference_type'],
  string
> = {
  last_agent: 'last agent',
  preferred_agent: 'preferred agent',
  follow_up: 'follow-up',
};

/** Represents the info icon that explains who a conversation is reserved for, until when and why. */
export const ConversationsTableAgentPreferenceTooltip = ({
  agentPreference,
}: ConversationsTableAgentPreferenceTooltipProps): JSX.Element => (
  <Tooltip
    content={
      <>
        Conversation is reserved for{' '}
        <b>{getUserDisplayName(agentPreference.agent)}</b> until{' '}
        <ConversationTimestamp
          time={agentPreference.valid_until}
          isSecondsDisplayed={false}
          textProps={{
            as: 'span',
            variant: '2',
            subdued: false,
            color: 'inherit',
          }}
        />{' '}
        with reason:{' '}
        <b>
          {prettyAgentPreferenceType[agentPreference.agent_preference_type]}
        </b>
      </>
    }
    className={styles.tooltip}
    wrapProps={{ className: styles.wrap }}
  >
    <Icon name="info" size={20} color={typography.color.secondary} />
  </Tooltip>
);
